/* Diwali edit (Diwali 2026). Loaded (defer) only by sections/mes-diwali-edit.liquid.
   Parts: rangoli hero (canvas, plays once) · gift ladder (live cart + auto-add) · deal of the day
   (IST day pick + midnight countdown + ajax add) · timers. The canvas code is a port of the
   design's logic.js (buildRangoli / drawRangoli / petal / paisley / bgFill / glow / bead).
   Several Diwali sections on one page each emit this tag: the guard below runs it once. */
(function () {
  'use strict';
  if (window.__mesDiwali) return;
  window.__mesDiwali = true;

  var RM = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var IST = 5.5 * 3600e3;
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function pad(n) { return String(n).padStart(2, '0'); }
  function inr(n) { return '₹' + Math.max(0, Math.round(n)).toLocaleString('en-IN'); }
  function istDate(ms) {
    var d = new Date(ms + IST);
    return d.getUTCFullYear() + '-' + pad(d.getUTCMonth() + 1) + '-' + pad(d.getUTCDate());
  }
  function json(el) { try { return JSON.parse(el.textContent) || {}; } catch (e) { return {}; } }
  function formatMoney(cents) {
    var f = (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.moneyFormat) || '₹{{amount_no_decimals}}';
    /* the store's money format carries HTML (<span class=money>); prices here are set as text, so strip the tags */
    f = String(f).replace(/<[^>]*>/g, '');
    cents = Number(cents) || 0;
    function grp(num, dec, ts, ds) {
      var p = (num / 100).toFixed(dec).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts);
      return p[1] ? p[0] + ds + p[1] : p[0];
    }
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount': return grp(cents, 2, ',', '.');
        case 'amount_no_decimals': return grp(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return grp(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return grp(cents, 0, '.', ',');
        default: return grp(cents, 2, ',', '.');
      }
    });
  }
  function fire(name, detail) {
    document.documentElement.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail || {} }));
  }
  var store = {
    get: function (k) { try { return JSON.parse(sessionStorage.getItem(k) || '[]'); } catch (e) { return []; } },
    set: function (k, v) { try { sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* private mode */ } }
  };

  /* ------------------------------------------------------------------------------------------
     Shared 1 s ticker (hero countdown, deal midnight countdown, IST day roll-over).
     ------------------------------------------------------------------------------------------ */
  var tickers = [];
  function onTick(fn) {
    tickers.push(fn);
    fn(Date.now());
    if (tickers.length === 1) {
      setInterval(function () {
        if (document.hidden) return;
        var now = Date.now();
        for (var i = 0; i < tickers.length; i++) tickers[i](now);
      }, 1000);
    }
  }

  /* ==========================================================================================
     RANGOLI (port of the design's canvas code; drawing space 1200 x 560)
     ========================================================================================== */
  var W = 1200, H = 560;
  var cl = function (x, a, b) { a = a === undefined ? 0 : a; b = b === undefined ? 1 : b; return Math.max(a, Math.min(b, x)); };
  var eo = function (x) { return 1 - Math.pow(1 - cl(x), 3); };
  var eio = function (x) { x = cl(x); return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2; };
  var ph = function (t, a, b) { return cl((t - a) / (b - a)); };
  var lerp = function (a, b, u) { return a + (b - a) * u; };
  var polar = function (r, a) { return [Math.cos(a) * r, Math.sin(a) * r]; };
  function rng(seed) {
    return function () {
      seed |= 0; seed = seed + 0x6D2B79F5 | 0;
      var t = Math.imul(seed ^ seed >>> 15, 1 | seed);
      t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t;
      return ((t ^ t >>> 14) >>> 0) / 4294967296;
    };
  }
  function glow(ctx, x, y, r, rgb, a) {
    if (a <= 0 || r <= 0) return;
    var g = ctx.createRadialGradient(x, y, 0, x, y, r);
    g.addColorStop(0, 'rgba(' + rgb + ',' + a + ')');
    g.addColorStop(1, 'rgba(' + rgb + ',0)');
    ctx.fillStyle = g; ctx.fillRect(x - r, y - r, 2 * r, 2 * r);
  }
  function bead(ctx, img, x, y, r, a) {
    if (a <= 0 || r <= 0) return;
    ctx.globalAlpha = cl(a);
    if (img && img.complete && img.naturalWidth) { ctx.drawImage(img, x - r, y - r, 2 * r, 2 * r); }
    else { ctx.fillStyle = '#C98A3A'; ctx.beginPath(); ctx.arc(x, y, r, 0, 7); ctx.fill(); }
    ctx.globalAlpha = 1;
  }
  function scrim(ctx, P) {
    var g = ctx.createRadialGradient(0, H, 0, 0, H, 780);
    var c = P.dark ? '6,9,24' : P.flat ? '253,252,246' : '251,241,220';
    g.addColorStop(0, 'rgba(' + c + ',.92)'); g.addColorStop(0.55, 'rgba(' + c + ',.55)'); g.addColorStop(1, 'rgba(' + c + ',0)');
    ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);
  }
  function bgFill(ctx, P) {
    var g = ctx.createRadialGradient(W * 0.72, H * 0.42, 10, W * 0.72, H * 0.42, W * 0.85);
    g.addColorStop(0, '#FFF8E8'); g.addColorStop(0.55, '#FBF1DC'); g.addColorStop(1, '#F0D7A4');
    ctx.fillStyle = g; ctx.fillRect(0, 0, W, H); scrim(ctx, P);
  }
  function petal(ctx, a, r0, r1, wd) {
    var b1 = polar(r0, a - wd * 0.5), b2 = polar(r0, a + wd * 0.5), c1 = polar(r0 + (r1 - r0) * 0.5, a - wd), c2 = polar(r0 + (r1 - r0) * 0.5, a + wd), tp = polar(r1, a);
    ctx.beginPath(); ctx.moveTo(b1[0], b1[1]); ctx.quadraticCurveTo(c1[0], c1[1], tp[0], tp[1]); ctx.quadraticCurveTo(c2[0], c2[1], b2[0], b2[1]); ctx.closePath();
  }
  function paisley(ctx) {
    ctx.beginPath(); ctx.moveTo(-10, 0);
    ctx.bezierCurveTo(-10, -14, 0, -20, 8, -27); ctx.bezierCurveTo(5, -17, 12, -9, 10, 0);
    ctx.arc(0, 0, 10, 0, Math.PI, false); ctx.closePath();
  }
  var BEAD_NAMES = ['Citrine', 'Carnelian', 'Sunstone', 'Tiger-Eye', 'Red-Jasper', 'Amber', 'Garnet', 'Pyrite', 'Gold-Hematite'];
  function buildRangoli() {
    var R = rng(7), beads = [], P = Math.PI;
    var add = function (g, ang, rad, r, img) { beads.push({ ang: ang, rad: rad, r: r, img: img, sa: ang + 2.2 + R() * 0.8, sr: rad * 2.4 + 260 + R() * 120, d: 0.2 + g * 0.55 + R() * 0.25 }); };
    add(0, 0, 0, 24, 'Citrine');
    for (var i = 0; i < 8; i++) add(1, i * P / 4, 58, 14, 'Carnelian');
    for (i = 0; i < 16; i++) add(2, i * P / 8 + P / 16, 96, 11.5, i % 2 ? 'Sunstone' : 'Tiger-Eye');
    for (var k = 0; k < 8; k++) { var a = k * P / 4 + P / 8; add(3, a, 140, 12, 'Red-Jasper'); add(3, a, 166, 10, 'Amber'); add(3, a, 188, 8, 'Garnet'); }
    for (i = 0; i < 40; i++) add(4, i * P / 20, 230, 6.5, i % 2 ? 'Pyrite' : 'Gold-Hematite');
    return { cx: 860, cy: 286, beads: beads };
  }
  var RP = { dark: false, glowRGB: '242,140,40' };
  function drawRangoli(ctx, t, P, S, I, st) {
    var ROT = t * 0.03;
    bgFill(ctx, P);
    {
      var gf = ph(t, 6.2, 6.4);
      var ex = (function (u) { return u * u * (3 - 2 * u) * 0.35 + (1 - Math.pow(1 - u, 3)) * 0.65; })(ph(t, 3.4, 6.2));
      if (gf < 1) {
        if (!st.OFF) { st.OFF = document.createElement('canvas'); st.OFF.width = W / 2; st.OFF.height = H / 2; }
        var o = st.OFF.getContext('2d');
        o.setTransform(0.5, 0, 0, 0.5, 0, 0);
        o.globalCompositeOperation = 'source-over';
        var g = o.createRadialGradient(S.cx, S.cy, 20, S.cx, S.cy, W * 0.9);
        g.addColorStop(0, '#1A1C42'); g.addColorStop(0.5, '#11132F'); g.addColorStop(1, '#080A1C');
        o.fillStyle = g; o.fillRect(0, 0, W, H);
        o.globalCompositeOperation = 'destination-out';
        S.beads.forEach(function (b) {
          var e = eo(ph(t, b.d, b.d + 1.6)); if (e <= 0.05) return;
          var an = lerp(b.sa, b.ang, e) + ROT, rd = lerp(b.sr, b.rad, e), x = S.cx + Math.cos(an) * rd, y = S.cy + Math.sin(an) * rd, r = b.r * (4 + 22 * e * e);
          var h = o.createRadialGradient(x, y, 0, x, y, r);
          h.addColorStop(0, 'rgba(0,0,0,' + (0.32 * e) + ')'); h.addColorStop(0.35, 'rgba(0,0,0,' + (0.18 * e) + ')'); h.addColorStop(0.7, 'rgba(0,0,0,' + (0.06 * e) + ')'); h.addColorStop(1, 'rgba(0,0,0,0)');
          o.fillStyle = h; o.fillRect(x - r, y - r, 2 * r, 2 * r);
        });
        if (ex > 0) {
          var RR = lerp(240, 1150, ex), hz = o.createRadialGradient(S.cx, S.cy, 0, S.cx, S.cy, RR);
          hz.addColorStop(0, 'rgba(0,0,0,1)'); hz.addColorStop(Math.max(0, (RR - 260) / RR), 'rgba(0,0,0,1)'); hz.addColorStop(1, 'rgba(0,0,0,0)');
          o.fillStyle = hz; o.fillRect(0, 0, W, H);
        }
        o.globalCompositeOperation = 'source-over';
        ctx.globalAlpha = 1 - gf; ctx.drawImage(st.OFF, 0, 0, W, H); ctx.globalAlpha = 1; ctx.globalCompositeOperation = 'source-over';
      }
    }
    var cx = S.cx, cy = S.cy, lp = eio(ph(t, 3.9, 5.7)), L = P.dark ? '226,199,122' : '180,86,12';
    if (lp > 0) {
      ctx.save(); ctx.translate(cx, cy); ctx.rotate(ROT);
      for (var k = 0; k < 8; k++) {
        petal(ctx, k * Math.PI / 4 + Math.PI / 8, 112, 214, 0.26);
        ctx.fillStyle = 'rgba(' + (P.dark ? '201,162,75' : '232,137,28') + ',' + ((P.dark ? 0.1 : 0.14) * lp) + ')'; ctx.fill();
        ctx.strokeStyle = 'rgba(' + L + ',' + (0.65 * lp) + ')'; ctx.lineWidth = 1.2; ctx.stroke();
      }
      ctx.strokeStyle = 'rgba(' + L + ',.55)'; ctx.lineWidth = 1;
      [77, 118].forEach(function (r) { ctx.beginPath(); ctx.arc(0, 0, r, -Math.PI / 2, -Math.PI / 2 + Math.PI * 2 * lp); ctx.stroke(); });
      ctx.setLineDash([2, 6]); ctx.beginPath(); ctx.arc(0, 0, 252, -Math.PI / 2, -Math.PI / 2 + Math.PI * 2 * lp); ctx.stroke(); ctx.setLineDash([]);
      for (k = 0; k < 8; k++) {
        ctx.save(); ctx.rotate(k * Math.PI / 4); ctx.translate(180, 0); ctx.rotate(Math.PI / 2);
        var sc = 0.85 + 0.15 * lp; ctx.scale(sc, sc); ctx.translate(0, 8); ctx.globalAlpha = lp;
        paisley(ctx); ctx.strokeStyle = 'rgba(' + L + ',.8)'; ctx.lineWidth = 1.3; ctx.stroke(); ctx.fillStyle = 'rgba(' + L + ',.12)'; ctx.fill();
        ctx.scale(0.55, 0.55); paisley(ctx); ctx.stroke();
        ctx.beginPath(); ctx.arc(0, 0, 3.5, 0, 7); ctx.fillStyle = 'rgba(' + L + ',.9)'; ctx.fill();
        ctx.restore();
      }
      ctx.globalAlpha = 1; ctx.restore();
    }
    ctx.globalCompositeOperation = P.dark ? 'lighter' : 'source-over';
    glow(ctx, cx, cy, 320, P.glowRGB, 0.14 * lp); glow(ctx, cx, cy, 90, P.glowRGB, 0.5 * eo(ph(t, 4.4, 5.6)));
    ctx.globalCompositeOperation = 'source-over';
    S.beads.forEach(function (b) {
      var e = eo(ph(t, b.d, b.d + 1.6)); if (e <= 0) return;
      var an = lerp(b.sa, b.ang, e) + ROT, rd = lerp(b.sr, b.rad, e);
      bead(ctx, I[b.img], cx + Math.cos(an) * rd, cy + Math.sin(an) * rd, b.r, Math.min(1, ph(t, b.d, b.d + 0.35)));
    });
  }

  /* Design timing: beads land by ~4.3 s, lines by 5.7 s, the navy veil clears at 6.4 s, copy at 5 s.
     The design then rotates forever; this plays ONCE and stops (Shrey's brief), holding t = DONE. */
  var DONE = 7, REVEAL = 5;
  function initHero(root) {
    root.classList.add('is-armed', 'is-js');
    var cv = root.querySelector('[data-mdw-rangoli]');
    var beadEl = root.querySelector('[data-mdw-beads]');
    var urls = beadEl ? json(beadEl) : {};
    var imgs = {}, imgsAsked = false;
    function loadImgs() {
      if (imgsAsked) return; imgsAsked = true;
      BEAD_NAMES.forEach(function (n) {
        var u = urls[n.toLowerCase().replace(/[^a-z]/g, '')];
        if (!u) return; // no store image: bead() draws the design's plain circle
        var i = new Image(); i.decoding = 'async'; i.src = u; imgs[n] = i;
      });
    }
    function reveal() { root.classList.add('is-revealed'); }
    if (!cv || !cv.getContext || !('IntersectionObserver' in window)) { reveal(); return; }
    var S = buildRangoli(), st = { OFF: null }, ctx = null, hiRes = false;
    function draw(t) {
      if (!ctx) {
        // The 1200 x 560 drawing is cover-fitted into the box, so on a wide desktop box at 2x it is stretched ~2.7x
        // and blurs. The animation keeps the old 1.5x store (cheap frames); the FINAL still frame (hiRes) is redrawn
        // at the shown size on desktop (dpr up to 2, capped at 3200 px wide). Phones never change.
        var dpr = Math.min(1.5, window.devicePixelRatio || 1), s = dpr;
        var bw = cv.clientWidth || 0, bh = cv.clientHeight || 0;
        if (hiRes && bw >= 1000) s = Math.min(Math.max(bw / W, bh / H) * Math.min(2, window.devicePixelRatio || 1), 3200 / W);
        s = Math.max(s, dpr);
        cv.width = Math.round(W * s); cv.height = Math.round(H * s);
        ctx = cv.getContext('2d'); ctx.setTransform(s, 0, 0, s, 0, 0);
        ctx.imageSmoothingQuality = 'high';
      }
      ctx.globalCompositeOperation = 'source-over'; ctx.globalAlpha = 1;
      drawRangoli(ctx, t, RP, S, imgs, st);
    }
    var started = false, done = false, inView = false, elapsed = 0, t0 = 0, raf = 0, last = 0;
    function finish() {
      done = true; if (raf) cancelAnimationFrame(raf); raf = 0;
      hiRes = true; ctx = null; // re-size the store for the sharp final frame
      draw(DONE); st.OFF = null; reveal();
    }
    function frame(now) {
      raf = 0;
      if (!inView || done) return;
      raf = requestAnimationFrame(frame);
      if (now - last < 33) return; // ~30 fps, as the design
      last = now;
      var t = elapsed + (now - t0) / 1000;
      if (t >= REVEAL) reveal();
      if (t >= DONE) { finish(); return; }
      draw(t);
    }
    function play() { if (raf || done) return; t0 = performance.now(); last = 0; raf = requestAnimationFrame(frame); }
    function pause() { if (raf) { cancelAnimationFrame(raf); raf = 0; } if (started && !done) elapsed += (performance.now() - t0) / 1000; }

    // Bead images: fetch shortly before the hero is reached, so the first beads are not circles.
    var pre = new IntersectionObserver(function (es) {
      if (es[0].isIntersecting) { loadImgs(); pre.disconnect(); }
    }, { rootMargin: '0px 0px 600px 0px' });
    pre.observe(cv);

    var io = new IntersectionObserver(function (es) {
      var e = es[es.length - 1];
      if (done) { io.disconnect(); return; }
      if (!started) {
        if (e.intersectionRatio >= 0.3) {
          started = true; loadImgs();
          if (RM) { finish(); io.disconnect(); return; }
          inView = true; elapsed = 0; play();
        }
        return;
      }
      if (e.isIntersecting && !inView) { inView = true; play(); }
      else if (!e.isIntersecting && inView) { inView = false; pause(); }
    }, { threshold: [0, 0.3] });
    io.observe(cv);

    // Hero button scrolls to the Shop your way section on this page; without it (or without JS) the link is followed.
    var cta = root.querySelector('[data-mdw-scroll]');
    if (cta) cta.addEventListener('click', function (e) {
      var t = document.querySelector('.msw');
      if (!t) return;
      e.preventDefault();
      var hh = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
      var y = t.getBoundingClientRect().top + window.pageYOffset - hh;
      var still = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: Math.max(0, y), behavior: still ? 'auto' : 'smooth' });
    });

    // "Offer ends in" countdown to Theme settings > Campaign ends.
    var timer = root.querySelector('[data-mdw-timer]'), val = root.querySelector('[data-mdw-timer-val]');
    var end = Date.parse(root.getAttribute('data-end') || '');
    if (timer && val && !isNaN(end)) {
      onTick(function (now) {
        var s = Math.floor((end - now) / 1000);
        if (s <= 0) { timer.hidden = true; return; }
        val.textContent = pad(Math.floor(s / 86400)) + 'd ' + pad(Math.floor(s % 86400 / 3600)) + 'h ' + pad(Math.floor(s % 3600 / 60)) + 'm';
        timer.hidden = false;
      });
    }
  }

  /* ==========================================================================================
     GIFT LADDER
     Ladder total = cart.items_subtotal_price minus every line carrying the _mes_gift property.
     Auto-add (India only): a tier's gift goes in once when the total reaches it and comes out
     when the total drops below. Loop guards: one reconcile at a time, always against a FRESH
     /cart.js read (an event's cart can be older than our own write), a gift the shopper removed
     is never re-added this session, and a hard cap on writes per window.
     ========================================================================================== */
  var KEY_ADDED = 'mdwGiftAdded', KEY_DECLINED = 'mdwGiftDeclined';
  var ladders = [], gift = null;

  function ladderTotal(cart) {
    var t = Number(cart.items_subtotal_price);
    if (isNaN(t)) t = Number(cart.total_price) || 0;
    (cart.items || []).forEach(function (it) {
      if (it.properties && it.properties._mes_gift) t -= Number(it.final_line_price) || 0;
    });
    return Math.max(0, t) / 100;
  }

  function renderLadder(L, cart) {
    if (cart.currency && cart.currency !== 'INR') return; // thresholds are rupees: leave the server render
    var total = ladderTotal(cart), T = L.data.t || {}, left = 0, next = null;
    L.tiers.forEach(function (t) {
      var on = total >= t.amt;
      if (!on) { left++; if (!next || t.amt < next.amt) next = t; }
      if (t.el) {
        t.el.classList.toggle('is-on', on);
        if (t.chip) t.chip.textContent = on ? (T.chipOn || '') : String(T.chipOff || '').replace('[amount]', inr(t.amt - total));
      }
    });
    if (L.title) L.title.textContent = left === 0 ? (T.done || '') : left === 1 ? (T.one || '') : String(T.many || '').replace('[count]', left);
    if (L.total) L.total.textContent = inr(total);
    if (L.msg) {
      L.msg.textContent = next
        ? String(T.next || '').replace('[amount]', inr(next.amt - total)).replace('[gift]', String(next.name || '').toLowerCase())
        : (T.all || '');
    }
  }

  function initLadder(root) {
    var dataEl = root.querySelector('[data-mdw-lad-data]');
    if (!dataEl) return;
    var data = json(dataEl);
    var L = {
      root: root, data: data,
      title: root.querySelector('[data-mdw-lad-title]'),
      total: root.querySelector('[data-mdw-lad-total]'),
      msg: root.querySelector('[data-mdw-lad-msg]'),
      tiers: (data.tiers || []).map(function (t) {
        var el = root.querySelector('[data-mdw-tier="' + t.key + '"]');
        return { key: String(t.key), amt: Number(t.amt) || 0, name: t.name, vid: Number(t.vid) || 0, avail: !!t.avail, el: el, chip: el && el.querySelector('[data-mdw-chip]') };
      })
    };
    ladders.push(L);
    if (!gift) gift = createGiftController(L);
  }

  function createGiftController(L) {
    var country = (window.Shopify && window.Shopify.country) || L.data.country || '';
    /* V9.28.263: when the site-wide engine (snippets/mes-diwali-gifts.liquid) is on the page it owns the adds and
       removals; the ladder then only paints. */
    var auto = !document.querySelector('[data-mdw-gifts]') && L.data.autoAdd !== false && country === 'IN';
    var busy = false, again = false, timer = 0, writes = [], halted = false;

    function fetchCart() {
      return fetch(ROOT + 'cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); });
    }
    function post(path, body) {
      writes.push(Date.now());
      return fetch(ROOT + path, {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || r.status); return j; }); });
    }
    function capped() {
      var now = Date.now();
      writes = writes.filter(function (w) { return now - w < 30000; });
      if (writes.length >= 8) {
        halted = true;
        console.warn('[mes-diwali] gift auto-add stopped for this page: too many cart writes in 30s');
      }
      return halted;
    }

    function reconcile(cart) {
      if (!auto || halted || cart.currency && cart.currency !== 'INR') return Promise.resolve(false);
      var total = ladderTotal(cart), items = cart.items || [];
      var added = store.get(KEY_ADDED), declined = store.get(KEY_DECLINED);
      var adds = [], changes = [];
      L.tiers.forEach(function (t) {
        var lines = items.filter(function (it) { return it.properties && String(it.properties._mes_gift) === t.key; });
        var has = lines.length > 0;
        var want = total >= t.amt && t.vid > 0 && t.avail;
        if (want && !has) {
          if (declined.indexOf(t.key) !== -1) return;
          if (added.indexOf(t.key) !== -1) {
            // We put it in, the cart still qualifies, and it is gone: the shopper took it out. Respect that.
            declined.push(t.key);
            added.splice(added.indexOf(t.key), 1);
            return;
          }
          adds.push({ id: t.vid, quantity: 1, properties: { _mes_gift: t.key } });
        } else if (!want && has) {
          lines.forEach(function (ln) { changes.push({ id: ln.key, quantity: 0 }); });
          if (added.indexOf(t.key) !== -1) added.splice(added.indexOf(t.key), 1);
        } else if (has) {
          // One gift per tier: fold extra quantity or duplicate lines back to a single unit.
          lines.forEach(function (ln, i) { var q = i === 0 ? 1 : 0; if (ln.quantity !== q) changes.push({ id: ln.key, quantity: q }); });
          if (added.indexOf(t.key) === -1) added.push(t.key);
        }
      });
      store.set(KEY_DECLINED, declined);
      store.set(KEY_ADDED, added);
      if (!adds.length && !changes.length) return Promise.resolve(false);
      if (capped()) return Promise.resolve(false);

      var chain = Promise.resolve();
      changes.forEach(function (c) { chain = chain.then(function () { return post('cart/change.js', c); }); });
      if (adds.length) {
        chain = chain.then(function () { return post('cart/add.js', { items: adds }); }).then(function () {
          var a = store.get(KEY_ADDED);
          adds.forEach(function (x) { var k = x.properties._mes_gift; if (a.indexOf(k) === -1) a.push(k); });
          store.set(KEY_ADDED, a);
        });
      }
      return chain.then(function () { return true; }, function (err) {
        console.warn('[mes-diwali] gift update failed:', err && err.message);
        return true; // something may have changed before the failure: let the theme repaint
      });
    }

    function run() {
      if (busy) { again = true; return; }
      busy = true;
      fetchCart().then(function (cart) {
        ladders.forEach(function (Lx) { renderLadder(Lx, cart); });
        return reconcile(cart);
      }).then(function (wrote) {
        if (wrote) fire('cart:refresh'); // drawer + badge repaint; its own cart:change lands back here as a no-op
      }).catch(function (e) {
        console.warn('[mes-diwali] ladder:', e && e.message);
      }).then(function () {
        busy = false;
        if (again) { again = false; schedule(); }
      });
    }
    function schedule() { clearTimeout(timer); timer = setTimeout(run, 250); }
    function onEvent(e) {
      var c = e && e.detail && e.detail.cart;
      if (c && Array.isArray(c.items)) ladders.forEach(function (Lx) { renderLadder(Lx, c); }); // instant paint
      schedule();
    }
    ['cart:change', 'cart:refresh', 'variant:add'].forEach(function (n) { document.addEventListener(n, onEvent); });
    window.addEventListener('pageshow', function (e) { if (e.persisted) schedule(); });
    schedule();
    return { schedule: schedule };
  }

  /* ==========================================================================================
     DEAL OF THE DAY
     ========================================================================================== */
  function initDeal(root) {
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-mdw-day]'));
    var days = Array.prototype.slice.call(root.querySelectorAll('[data-mdw-dayl]'));
    var empty = root.querySelector('[data-mdw-deal-empty]');
    var shownDay = null;
    function pick(now) {
      var today = istDate(now);
      if (today === shownDay) return;
      shownDay = today;
      var any = false, last = '';
      cards.forEach(function (c) {
        var d = c.getAttribute('data-mdw-day'); if (d > last) last = d;
        var on = d === today; c.hidden = !on; if (on) any = true;
      });
      days.forEach(function (li) {
        var d = li.getAttribute('data-mdw-dayl');
        li.classList.toggle('is-today', d === today);
        li.classList.toggle('is-past', d < today);
      });
      if (empty) empty.hidden = true;
      // After the last deal day the whole part retires itself.
      root.hidden = !any && last && today > last;
    }
    onTick(function (now) {
      pick(now);
      var d0 = new Date(now + IST);
      var ms = 86400 - (d0.getUTCHours() * 3600 + d0.getUTCMinutes() * 60 + d0.getUTCSeconds());
      var txt = pad(Math.floor(ms / 3600)) + ':' + pad(Math.floor(ms % 3600 / 60)) + ':' + pad(ms % 60);
      cards.forEach(function (c) { if (!c.hidden) { var el = c.querySelector('[data-mdw-midcd]'); if (el) el.textContent = txt; } });
    });

    cards.forEach(function (card) {
      var mainImg = card.querySelector('.mdw-deal__main img');
      card.querySelectorAll('[data-mdw-thumb]').forEach(function (b) {
        b.addEventListener('click', function () {
          card.querySelectorAll('[data-mdw-thumb]').forEach(function (x) { x.classList.toggle('is-on', x === b); });
          if (mainImg) { mainImg.removeAttribute('srcset'); mainImg.src = b.getAttribute('data-mdw-thumb'); }
        });
      });
      var form = card.querySelector('[data-mdw-deal-form]');
      if (!form) return;
      var sel = form.querySelector('[data-mdw-variant]');
      var qty = form.querySelector('[data-mdw-qtyv]');
      var atc = form.querySelector('[data-mdw-atc]');
      var priceEl = card.querySelector('[data-mdw-price]');
      var mrpEl = card.querySelector('[data-mdw-mrp]');
      var label = atc ? atc.getAttribute('data-label') : '';
      var soldOut = atc ? atc.textContent : '';
      var baseAvail = atc ? !atc.disabled : false; // server truth for a single-variant product
      function q() { var n = parseInt(qty && qty.value, 10); return isNaN(n) ? 1 : Math.min(9, Math.max(1, n)); }
      function paint() {
        var price = Number(atc && atc.getAttribute('data-price')) || 0, mrp = 0, avail = baseAvail;
        if (sel) {
          var o = sel.options[sel.selectedIndex];
          price = Number(o.getAttribute('data-price')) || 0; mrp = Number(o.getAttribute('data-mrp')) || 0; avail = !o.disabled;
          if (priceEl) priceEl.textContent = formatMoney(price);
          if (mrpEl) { mrpEl.textContent = formatMoney(mrp); mrpEl.hidden = !(mrp > price); }
        }
        if (atc) {
          atc.disabled = !avail;
          atc.textContent = avail ? label + ' · ' + formatMoney(price * q()) : soldOut;
        }
      }
      if (sel) sel.addEventListener('change', paint);
      form.querySelectorAll('[data-mdw-qty]').forEach(function (b) {
        b.addEventListener('click', function () { qty.value = Math.min(9, Math.max(1, q() + Number(b.getAttribute('data-mdw-qty')))); paint(); });
      });
      if (qty) qty.addEventListener('change', function () { qty.value = q(); paint(); });
      form.addEventListener('submit', function (e) {
        if (!window.fetch) return; // native POST to /cart/add
        e.preventDefault();
        var id = Number((sel || form.querySelector('input[name="id"]')).value);
        if (!id || (atc && atc.disabled)) return;
        if (atc) atc.disabled = true;
        var landed = false;
        fetch(ROOT + 'cart/add.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: [{ id: id, quantity: q() }] })
        }).then(function (r) {
          return r.json().then(function (j) { return { ok: r.ok, status: r.status, j: j }; });
        }).then(function (res) {
          if (!res.ok) {
            if (res.status === 422) { if (atc) { atc.textContent = res.j.description || res.j.message || soldOut; setTimeout(paint, 2500); } return; }
            throw new Error(res.status);
          }
          landed = true;
          return fetch(ROOT + 'cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (cart) {
            fire('variant:add', { items: res.j.items || [res.j], cart: cart, blockCartDrawerOpening: false });
            fire('cart:refresh');
            paint();
          });
        }).catch(function () {
          if (!landed) { form.submit(); return; } // the add itself failed: fall back to the plain /cart/add post
          fire('cart:refresh');
        }).then(function () { if (atc && atc.textContent.indexOf(label) === 0) atc.disabled = false; });
      });
      paint();
    });
  }

  function boot() {
    document.querySelectorAll('[data-mdw-hero]').forEach(initHero);
    document.querySelectorAll('[data-mdw-ladder]').forEach(initLadder);
    document.querySelectorAll('[data-mdw-deal]').forEach(initDeal);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
